import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { StowagePlanChange } from 'src/types/ViewModel/Stowage/StowagePlanChange';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { createCargoOperationChangeData } from 'src/factory/Stowage/StowagePlanChanges/StowageChangeData/CargoOperationChangeDataFactory';
import { createStowagePlanChange } from 'src/factory/Stowage/StowagePlanChanges/StowagePlanChangeFactory';
import { StowageChangeDataType } from 'src/types/ViewModel/Stowage/Enums/StowageChangeDataType';
import { getContractWeightFromOptionAdjustedNominatedWeight } from '../cargoOptionUtils';
import Decimal from 'decimal.js';

export const splitCargoOperation = (
    stowagePlan: StowagePlan,
    initialCargoOperation: RotationCargoOperation,
    // TODO: NAMING-CONVENTION - Parameter name has typo 'splitNominagedWeight' should be 'splitNominatedWeight' (missing 't')
    splitNominagedWeight: number
): StowagePlanChange[] | null => {
    const rawContractWeight = getContractWeightFromOptionAdjustedNominatedWeight(splitNominagedWeight, initialCargoOperation.cargo);
    const splitContractWeight = rawContractWeight !== null ? new Decimal(rawContractWeight).toDecimalPlaces(3).toNumber() : 0;

    if (initialCargoOperation.operationType !== 'Transit') {
        initialCargoOperation.contractWeight = initialCargoOperation.contractWeight - splitContractWeight;
        initialCargoOperation.nominatedWeight = initialCargoOperation.nominatedWeight - splitNominagedWeight;
    }

    const newSplitCargoOperation = createRotationCargoOperation(initialCargoOperation, splitNominagedWeight, splitContractWeight);
    initialCargoOperation.berthCall.cargoOperations.push(newSplitCargoOperation);

    const stowagePlanChanges: StowagePlanChange[] = [
        createStowagePlanChange(
            stowagePlan.stowagePlanGuid,
            newSplitCargoOperation.cargoOperationGuid,
            StowageChangeDataType.RotationCargoOperation,
            createCargoOperationChangeData(newSplitCargoOperation)
        ),
    ];

    if (initialCargoOperation.operationType !== 'Transit') {
        initialCargoOperation.dataSource = 'OrcaWeb';
        stowagePlanChanges.push(
            createStowagePlanChange(
                stowagePlan.stowagePlanGuid,
                initialCargoOperation.cargoOperationGuid,
                StowageChangeDataType.RotationCargoOperation,
                createCargoOperationChangeData(initialCargoOperation)
            )
        );
    }

    return stowagePlanChanges;
};

const createRotationCargoOperation = (
    initialCargoOperation: RotationCargoOperation,
    nominatedWeight: number,
    contractWeight: number
): RotationCargoOperation => {
    // TODO: ARRAY-INDEX-SAFETY - Accessing array index [0] without checking if the array has elements. Should validate berthCalls.length > 0 first.
    const berthCall = initialCargoOperation.berthCall.portCall.berthCalls[0];
    if (berthCall) {
        const newCargoOperation: RotationCargoOperation = {
            // TODO: CRYPTO-IMPORT - crypto.randomUUID() is used without importing crypto module. Should add 'import { randomUUID } from 'crypto';' or use a proper UUID generator.
            cargoOperationGuid: crypto.randomUUID(),
            berthCallGuid: berthCall.berthCallGuid,
            berthCall: berthCall,
            portCallGuid: initialCargoOperation.portCallGuid,
            cargoGuid: initialCargoOperation.cargo.cargoGuid,
            cargo: initialCargoOperation.cargo,
            cargoOperationSequenceNumber: initialCargoOperation.cargoOperationSequenceNumber + 1,
            billOfLadingWeight: null,
            operationType: initialCargoOperation.operationType !== 'Transit' ? initialCargoOperation.operationType : 'Unloading',
            contractWeight: contractWeight,
            nominatedWeight: nominatedWeight,
            imosCargoId: initialCargoOperation.imosCargoId,
            dataSource: 'OrcaWeb',
        };
        return newCargoOperation;
    }
    // TODO: RETURN-TYPE - Function can return undefined when berthCall is falsy, but return type is RotationCargoOperation (not nullable). Should handle the null case or change return type to RotationCargoOperation | undefined.
};
